import { render, staticRenderFns } from "./whatsAppTemplates.vue?vue&type=template&id=01e32432&"
import script from "./whatsAppTemplates.vue?vue&type=script&lang=ts&"
export * from "./whatsAppTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports